<div class="divider margin_bottom_medium margin_top_large">
    <div class="line full_width"></div>
    <p class="h_padding_small bg_white_high_emphasis">{{ text }}</p>
</div>